import type { ImmerStateCreator } from 'hooks/useStore';

/**
 * @descripiton This slice is a meant for sharing data between studio
 * during preview or assessment if someone want to use data from previous page.
 * We can access it through this slice
 * the way we handle data flow in studio need to be refined much further
 * right now there are disrepancies between each page/blocks?
 * table page, form page, etc. Cannot communicate with each other
 * because each has it's own hook-form and that there is no way to share data between them
 * hence this slice
 */
export interface StudioSlice {
  fieldDefRecord: Record<string, any>;
  setFieldDefs: (fieldDefs: Record<string, any>) => void;
}

export const useStudioSlice: ImmerStateCreator<StudioSlice> = (set) => ({
  fieldDefRecord: {},
  setFieldDefs: (values: Record<string, any>) =>
    set(
      (state) => {
        state.studioSlice.fieldDefRecord = values;
      },
      false,
      'setFieldDefs'
    ),
});
